/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//Floating add button handling in snippets/product-item.liquid
var FloatingAddButton = {

     Toast : Swal.mixin({
        toast: true,
        position: 'top-start',
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true
    }),

    init : function(){
        document.querySelectorAll('.ProductItem__AddButton[data-variant-id]')
            .forEach(function (elem) {
                FloatingAddButton.attachHandler(elem);
            });
    },

    attachHandler : function(element){
         element.addEventListener('click', FloatingAddButton.addButtonHandler);
    },

    addButtonHandler : function(elem) {
        if (!elem.matches('.ProductItem__AddButton[data-variant-id]'))
            return;

        let button = elem;
        if (button.classList.contains('fa-spin'))
            return;

        FloatingAddButton.setLoadingButton(button);
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: button.dataset.variantId
                }]
            })
        })
            .then(function(response){
                if (!response.ok){
                    FloatingAddButton.Toast.fire({
                        icon: 'error',
                        title: "Erreur lors de l'ajout. Ré-essayez ou rendez-vous directement sur la page produit"
                    });
                    return;
                }

                response.json().then(function (data) {
                    FloatingAddButton.Toast.fire({
                        icon: 'success',
                        title: `${data.items[0].title} ajouté au panier !`
                    });
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                })
            })
            .catch(function (error) {
                FloatingAddButton.Toast.fire({
                    icon: 'error',
                    title: "Erreur lors de l'ajout. Ré-essayez ou rendez-vous directement sur la page produit"
                })
            })
            .finally(function(){
                FloatingAddButton.resetButton(button);
            });
    },

    setLoadingButton : function(elem){
        elem.classList.remove('fa-cart-plus');
        elem.classList.add('fa-spin', 'fa-circle-notch');
    },

    resetButton: function(elem) {
        elem.classList.remove('fa-spin', 'fa-circle-notch');
        elem.classList.add('fa-cart-plus');
    }
};
